let base64 = require("base-64");
import global from '@/utils/global'

export function dealForm(form) {
    if(typeof form != 'object') return false
    let form_str = [];
    let form_data = form;
    for(let key in form_data) {
        form_str.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(form_data[key])
        )
    }
    
    form_str = form_str.join('&')
    
    let form_delt = base64.encode(form_str);
    let fd = new FormData();
    fd.append("form", form_delt);
    return fd
}


